export type UsabillaEventName =
  'trigger' |
  'virtualPageView' |
  'data' |
  'setEventCallback'

export const UsabillaEventActions = {
  CampaignClose: 'Campaign:Close',
  CampaignOpen: 'Campaign:Open'
}

export interface GetFeedbackUserData {
  language?: string;
  user_id?: number;
  user_pseudo_id?: string;
  country?: string;
  after_registration?: boolean;
  group_id?: string;
}